//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';
export default {
  name: 'MainAreaOverlay',
  components: {NsIcon},
  props: {
    favorite: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleFavoriteClick(event) {
      this.$emit('favorite-click');
    }
  }
};
